export default __webpack_public_path__ + "static/media/Group 1874.6216edbc.svg";